import { useState } from "react";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { buyProduct } from "@/data/tiers";

// Compact sticky buy bar shown on mobile only when a product is available.
// Desktop already has the in-flow button up top.
const StickyBuyBar = ({ product }) => {
  const [buying, setBuying] = useState(false);

  if (!product || product.status !== "available") return null;

  const onBuy = async () => {
    setBuying(true);
    try {
      await buyProduct(product.slug);
    } catch {
      toast.error("Could not start checkout. Please try again.");
      setBuying(false);
    }
  };

  return (
    <div
      data-testid="sticky-buy-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-sm border-t border-[#E7E7E2] px-4 py-3 flex items-center justify-between gap-3"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="min-w-0">
        <div className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#111111]/45">
          Kit · {product.no}
        </div>
        <div className="font-sora text-[15px] font-semibold text-[#111111] truncate">
          {product.name}
        </div>
      </div>
      <button
        type="button"
        onClick={onBuy}
        disabled={buying}
        data-testid="sticky-buy-cta"
        className="shrink-0 inline-flex items-center gap-2 bg-[#2563EB] text-white font-manrope font-medium text-sm px-4 py-2.5 rounded-lg disabled:opacity-60"
      >
        {buying ? (
          <>
            Opening…
            <Loader2 size={14} strokeWidth={2.25} className="animate-spin" />
          </>
        ) : (
          <>
            {product.price ? `Buy · ${product.price}` : "Buy"}
            <ArrowUpRight size={14} strokeWidth={2.25} />
          </>
        )}
      </button>
    </div>
  );
};

export default StickyBuyBar;
